import React from 'react';
import { Section } from './ui/Section';
import { Book, FileText, MessageCircle, CheckSquare } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: Book,
    title: 'Ebook completo "Puentes de Palabras"',
    desc: 'Edición Perú. Lectura ágil y directa.'
  }, {
    icon: FileText,
    title: 'Plantilla del Diccionario Familiar',
    desc: 'Una sola página para co-crear con ellos.'
  }, {
    icon: MessageCircle,
    title: '30 Frases de Rescate',
    desc: 'Para cortar discusiones sin humillar a nadie.'
  }, {
    icon: CheckSquare,
    title: 'Checklist "Antes de llamar"',
    desc: '30 segundos de preparación mental para no caer en lo mismo.'
  }];
  return <Section background="stone" data-id="element-37">
      <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 text-center mb-8" data-id="element-38">
        Qué incluye tu compra
      </h2>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-39">
        {items.map((item, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm flex items-start gap-3" data-id="element-40">
            <div className="bg-orange-100 p-2 rounded-lg text-orange-700" data-id="element-41">
              <item.icon size={20} data-id="element-42" />
            </div>
            <div data-id="element-43">
              <h3 className="font-bold text-stone-900 text-base" data-id="element-44">
                {item.title}
              </h3>
              <p className="text-stone-600 text-sm" data-id="element-45">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}